import ReportBox from "./reportBox";

export default ReportBox;
